<ng-container *ngIf="!inbound">
  <app-approver-comment-post [resourceType]="response_id" [resourceId]="resourceId"></app-approver-comment-post>
</ng-container>


<app-approver-comment-item [inbound]="inbound" [resourceId]="resourceId" [isMasterAdmin]="isMasterAdmin" [comment]="comment" *ngFor="let comment of comments; trackBy: trackByFunc"></app-approver-comment-item>
<!-- <skeleton-comment-item *ngIf="loadCommentStatus.isLoading"></skeleton-comment-item> -->

